import { BaseService } from "@services/BaseService";
import { DonorPayload } from "@shared/interfaces/ProgramFiles";

class DonorService extends BaseService {
  createDonor(data: DonorPayload) {
    return this.post("/programs/donors", data);
  }

  getAllDonors() {
    return this.get("/programs/donors");
  }

  getDonorById(donorId: string | number) {
    return this.get(`/programs/donors/${donorId}`);
  }

  deleteDonor(donorId: string | number) {
    return this.delete(`/programs/donors/${donorId}`);
  }

  searchDonorsByName(searchQuery: string) {
    return this.get("/programs/donors/search", {
      params: { search_query: searchQuery },
    });
  }
}

export const donorService = new DonorService();
